import { Component, HostListener, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { UtilsService } from '../../services/utils.service';


export interface AutocompleteInputOptions {
  value: any,
  displayOption: string
}

@Component({
  selector: 'ben-select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.scss']
})
export class SelectAutocompleteComponent implements OnInit {
  @ViewChild('overlayInput') overlayInput: any;
  @Input() label: string;
  @Input() control: FormControl;
  @Input() pattern: string;
  @Input() getOptions: Observable<AutocompleteInputOptions[]>;

  mobileDevice: boolean = false;
  panelOpen: boolean = false;
  keyboardOffset: number;
  constructor(private utilsService: UtilsService) { }
  ngOnInit(): void {
    this.mobileDevice = this.utilsService.isMobileAgent();
  }

  closeOnBlur($event: any, trigger: MatAutocompleteTrigger) {
    if ($event.relatedTarget == null) {
      $event.target.blur();
      trigger.closePanel();
    }
  }

  openOnClick(trigger: MatAutocompleteTrigger) {
    if (trigger && !trigger.panelOpen)
      trigger.openPanel();

    if (this.mobileDevice) {
      this.panelOpen = true;
      var setFocus: any = setTimeout(() => {
        if (this.overlayInput.nativeElement) {
          this.overlayInput.nativeElement.focus();
        } else {
          setFocus.refresh();
        }
      }, 100)
        
    }
  }

  setValueFromOverlay(value: any) {
    this.control.setValue(value);
    this.panelOpen = false;
  }

  clearValue() {
    this.control.setValue("");
  }

  @HostListener('window:resize') onScreenResize() {
    if (this.mobileDevice && this.panelOpen) {
      this.overlayInput.nativeElement.focus();
    }
  }
}
